<template>
  <div>
    <div class="input-row">
      <!-- 数量-->
      <el-form-item>
        <el-input
            type="number"
            v-model="food[langCurrent].amount"
            @blur="handleFoodInputBlur"
            :disabled="disabled"
            style="width: 90px"
        ></el-input>
      </el-form-item>

      <!--单位-->
      <el-form-item>
        <el-select
            v-model="food[langCurrent].unit"
            @blur="handleFoodInputBlur"
            :placeholder="$t('lang.请选择')"
            filterable
            :disabled="disabled"
            clearable
            class="unit-select">
          <el-option v-for="(unit, index) in unitList" :key="index" :label="unit.value" :value="unit.value" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-input @blur="handleFoodInputBlur" :disabled="disabled" v-model="food[langCurrent].nutritionName"></el-input>
      </el-form-item>

      <i
          v-if="!disabled"
          class="el-icon-circle-close input-icon"
          @click="$emit('remove', food)"/>
    </div>

    <nation-list
        :list="supportLangList"
        :lang="lang"
        :high-light="highlightList"
        @click="handleChangeLang" />
  </div>
</template>

<script>
import NationList from "../nation/NationList";

export default {
  name: "NutritionIngredient",
  components: {NationList},
  model: {
    prop: "food",
    event: "change"
  },
  props: {
    supportLangList: {
      type: Array,
      default() {
        return []
      }
    },
    lang: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    food: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      langCurrent: this.lang,
      highlightList: []
    }
  },
  methods: {
    // 切换语言
    handleChangeLang(lang) {
      this.langCurrent = lang.value;
      this.handleCheckHighlight();
    },

    // 食材失去焦点校验赋值
    handleFoodInputBlur() {
      if(this.langCurrent === this.lang) {
        for (const key in this.food) {
          if(key === this.lang || key === 'number') continue;
          // 如果 主语言lang 输入值，其他语言没有值则默认替换主语言输入的值
          if (this.food[this.lang].amount && !this.food[key].amount) this.food[key].amount = this.food[this.lang].amount;
          if (this.food[this.lang].unit && !this.food[key].unit) this.food[key].unit = this.food[this.lang].unit;
          if (this.food[this.lang].nutritionName && !this.food[key].nutritionName) this.food[key].nutritionName = this.food[this.lang].nutritionName;
        }
      }
      this.handleCheckHighlight();
      this.$emit("change", this.food);
    },

    // 检查是否高亮
    handleCheckHighlight() {
      let highlight = [];
      for (let key in this.food) {
        let values = Object.values(this.food[key]).filter(item  => item);
        if(values.length === 3) highlight.push(key);
      }
      this.highlightList = highlight;
    },
  },
  computed: {
    unitList() {
      return this.$store.state.recipeUnit;
    }
  },
}
</script>

<style scoped>


.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.unit-select {
  width: 160px;
}

.input-icon {
  color: red;
  font-size: 26px;
  margin-left: 14px;
}

</style>